module.exports = __webpack_public_path__ + "fonts/Manrope-400-latin-ext5_1a780b6.woff2";